import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import dayjs from '../../config/dayjs';
import { formatMoney } from '../../helpers/money';
import DicomComponent from '../dicom/DicomComponent';
import DateTimeCell from './DateTimeCell';

const DicomDetailsCell = ({ masterEntity }) => {
  const {
    currentDicom: dicom = null,
    currentDicomPlatinum: dicomPlatinum = null,
    isNaturalPersonRut,
  } = masterEntity ?? {
    currentDicom: null,
    currentDicomPlatinum: null,
    isNaturalPersonRut: false,
  };
  const createdAt = useMemo(
    () => dicom?.createdAt ?? dicomPlatinum?.createdAt,
    [dicom, dicomPlatinum],
  );
  const amount = useMemo(
    () => dicom?.dicomAmount ?? dicomPlatinum?.dicomAmount,
    [dicom, dicomPlatinum],
  );

  const isProcessed = useMemo(
    () => dicom?.completedAt ?? dicomPlatinum?.completedAt,
    [dicom, dicomPlatinum],
  );

  const amountToDisplay = isProcessed ? `$${formatMoney(amount)}` : 'No procesado';

  return (
    <Stack direction="row" spacing={2}>
      {masterEntity && (
        <DicomComponent
          isNaturalPersonRut={isNaturalPersonRut}
          masterEntityId={masterEntity.id}
          disabled={createdAt === undefined}
        />
      )}
      {createdAt && (
        <Stack direction="column" alignSelf="center">
          <DateTimeCell fullDate={dayjs(createdAt)} />
          <Typography>{amountToDisplay}</Typography>
        </Stack>
      )}
    </Stack>
  );
};

DicomDetailsCell.propTypes = {
  masterEntity: PropTypes.shape({
    id: PropTypes.string,
    currentDicom: PropTypes.shape({
      dicomAmount: PropTypes.number,
      createdAt: PropTypes.string,
      completedAt: PropTypes.string,
    }),
    currentDicomPlatinum: PropTypes.shape({
      dicomAmount: PropTypes.number,
      createdAt: PropTypes.string,
      completedAt: PropTypes.string,
    }),
    isNaturalPersonRut: PropTypes.bool,
  }).isRequired,
};

export default DicomDetailsCell;
